<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import { InvoicesRepository } from '../../modules/posApi/invoices/invoices.repository'
    import { InvoicesService } from '../../modules/posApi/invoices/invoices.service'
    import { Invoice } from '../../modules/posApi/invoices/invoice'
    import InlineSelect from '../_common/inline-select.svelte'
    import Fa from 'svelte-fa'
    import { faSave } from '@fortawesome/free-solid-svg-icons'

    const dispatch = createEventDispatcher()

    const rep = new InvoicesRepository()
    const service = new InvoicesService(rep)

    export let invoiceId: string = null

    let show = false
    let entity: Invoice = new Invoice()

    let formStatus: { value: any; label: string }[] = []
    formStatus.push({ label: 'Aberto', value: 'open' })
    formStatus.push({ label: 'Parcial', value: 'partial' })
    formStatus.push({ label: 'Fechado', value: 'closed' })
    formStatus.push({ label: 'Baixado', value: 'subsidized' })
    formStatus.push({ label: 'Crédito', value: 'credit' })

    onMount(async () => {
        await loadEntity(invoiceId)
    })

    async function loadEntity(id: string) {
        try {
            show = true
            entity = new Invoice()
            entity = await service.getOne(id)
            console.log('invoice', entity)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        updateEntity()
    }

    async function updateEntity() {
        try {
            if (show) return
            show = true
            if (!entity.status) {
                window.error('Informe o novo status')
                return false
            }
            const dto: Partial<Invoice> = {
                status: entity.status,
            }
            await service.update(invoiceId, dto)
            dispatch('change')
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }
</script>

<div class="root">
    <div class="grid-act">
        <div class="spacer" />
        {#if window.store.token.permissions.pos.sales.write}
            <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
        {/if}
    </div>

    <div class="grid-form">
        <div class="row">
            <InlineSelect small={true} options={formStatus} bind:value={entity.status} />
        </div>
        <div class="config-box m-3">
            <div class="row pos-entries-status">
                <div class="help-item">
                    <span class="badge">Aberto:</span>
                    <span class="help-text">venda em aberto e não paga</span>
                </div>
                <div class="help-item">
                    <span class="badge">Parcial:</span>
                    <span class="help-text">venda em aberto com pagamento parcial</span>
                </div>
                <div class="help-item">
                    <span class="badge">Fechado:</span>
                    <span class="help-text">venda finalizada e divergências serão lançadas no saldo do cliente</span>
                </div>
                <div class="help-item">
                    <span class="badge">Baixado:</span>
                    <span class="help-text">venda finalizada e divergências serão descartadas</span>
                </div>
                <div class="help-item">
                    <span class="badge">Crédito:</span>
                    <span class="help-text">pagamento do cliente lançado como crédito</span>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .row {
        padding: 0px 16px;
    }
    .pos-entries-status {
        font-size: 14px;
        opacity: 0.8;
        /* margin-bottom: 4px; */
    }
    .pos-entries-status > .help-item {
        margin-top: 2px !important;
        margin-bottom: 2px !important;
    }

    .pos-entries-status > .help-item .badge {
        background-color: #99999960;
        margin-right: 4px;
    }

    @media (max-width: 900px) {
        .root {
            display: flex;
            flex-direction: column-reverse;
        }
        .grid-act {
            background-color: unset;
            display: flex;
            justify-content: space-around;
        }
        .grid-act .btn {
            max-width: 120px;
            flex-grow: 1;
        }

        .pos-entries-status > .help-item .help-text {
            padding-left: 2px;
            display: block;
            margin-bottom: 3px;
        }
    }
</style>
